var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomepage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1536,
    height: 1024,
    viewBox: "0 0 1536 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1518_124)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1536,
    height: 1024,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 201.5,
    r: 53.5,
    fill: "#14B25F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 613.5,
    cy: 963.5,
    r: 35.5,
    fill: "#14B25F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1128,
    cy: 999,
    r: 53,
    fill: "#F74037"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1160.5,
    cy: 110.5,
    r: 70.5,
    fill: "#4A90F4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1126,
    cy: 1024,
    r: 131,
    stroke: "#B3D0FA",
    strokeWidth: 35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1443,
    cy: 255,
    r: 131,
    stroke: "#14B25F",
    strokeWidth: 35
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1548,
    cy: 532.5,
    rx: 86,
    ry: 90.5,
    stroke: "#4285F4",
    strokeWidth: 35
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 282,
    cy: 1016.5,
    rx: 86,
    ry: 90.5,
    stroke: "#14B25F",
    strokeWidth: 35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1124,
    cy: 1017,
    r: 126.5,
    stroke: "#4A90F4",
    strokeWidth: 5,
    strokeDasharray: "18 18"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1505,
    cy: 400,
    r: 126.5,
    stroke: "#F44A4A",
    strokeWidth: 5,
    strokeDasharray: "18 18"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 895,
    r: 126.5,
    stroke: "#14B25F",
    strokeWidth: 5,
    strokeDasharray: "18 18"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 103,
    r: 126.5,
    stroke: "#FFB808",
    strokeWidth: 5,
    strokeDasharray: "18 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.98 900.731C1146.87 906.251 1147.48 911.861 1147.78 917.545L1145.28 917.677C1145.43 920.434 1145.5 923.209 1145.5 926C1145.5 928.791 1145.43 931.566 1145.28 934.323L1147.78 934.455C1147.48 940.139 1146.87 945.749 1145.98 951.269L1143.51 950.871C1142.62 956.386 1141.44 961.811 1139.98 967.133L1142.4 967.793C1140.9 973.255 1139.12 978.609 1137.07 983.84L1134.74 982.927C1132.71 988.105 1130.4 993.162 1127.85 998.081L1130.07 999.233C1127.47 1004.24 1124.61 1009.11 1121.51 1013.82L1119.42 1012.44C1116.37 1017.07 1113.08 1021.56 1109.57 1025.87L1111.51 1027.45C1107.95 1031.81 1104.18 1036.01 1100.19 1040.02L1098.42 1038.25C1094.52 1042.19 1090.41 1045.94 1086.11 1049.49L1087.71 1051.42C1083.38 1055 1078.87 1058.39 1074.18 1061.56L1072.78 1059.5C1068.2 1062.6 1063.45 1065.51 1058.55 1068.19L1059.75 1070.38C1054.83 1073.08 1049.77 1075.56 1044.56 1077.81L1043.57 1075.52C1038.5 1077.71 1033.29 1079.69 1027.97 1081.42L1028.75 1083.8C1023.43 1085.54 1017.99 1087.05 1012.45 1088.31L1011.89 1085.87C1006.51 1087.1 1001.04 1088.09 995.474 1088.84L995.807 1091.32C990.269 1092.06 984.649 1092.56 978.959 1092.81L978.849 1090.32C976.082 1090.44 973.299 1090.5 970.5 1090.5C967.701 1090.5 964.918 1090.44 962.151 1090.32L962.041 1092.81C956.351 1092.56 950.731 1092.06 945.193 1091.32L945.526 1088.84C939.964 1088.09 934.486 1087.1 929.106 1085.87L928.551 1088.31C923.012 1087.05 917.575 1085.54 912.253 1083.8L913.029 1081.42C907.708 1079.69 902.504 1077.71 897.431 1075.52L896.438 1077.81C891.234 1075.56 886.166 1073.08 881.248 1070.38L882.45 1068.19C877.551 1065.51 872.804 1062.6 868.223 1059.5L866.82 1061.56C862.135 1058.39 857.621 1055 853.294 1051.42L854.888 1049.49C850.593 1045.94 846.485 1042.19 842.579 1038.25L840.806 1040.02C836.822 1036.01 833.046 1031.81 829.494 1027.45L831.433 1025.87C827.921 1021.56 824.632 1017.07 821.581 1012.44L819.493 1013.82C816.392 1009.11 813.533 1004.24 810.933 999.233L813.151 998.081C810.596 993.162 808.294 988.105 806.262 982.927L803.935 983.84C801.882 978.609 800.1 973.255 798.604 967.793L801.015 967.133C799.558 961.812 798.377 956.386 797.487 950.871L795.019 951.269C794.128 945.749 793.525 940.139 793.224 934.455L795.72 934.323C795.574 931.566 795.5 928.791 795.5 926C795.5 923.209 795.574 920.434 795.72 917.677L793.224 917.545C793.525 911.861 794.128 906.252 795.019 900.731L797.487 901.129C798.377 895.614 799.558 890.189 801.015 884.867L798.604 884.207C800.1 878.745 801.882 873.391 803.935 868.16L806.262 869.073C808.294 863.895 810.596 858.838 813.151 853.919L810.933 852.767C813.533 847.76 816.392 842.895 819.493 838.185L821.581 839.56C824.632 834.925 827.921 830.443 831.433 826.129L829.494 824.551C833.046 820.187 836.822 815.993 840.806 811.983L842.579 813.745C846.485 809.815 850.593 806.064 854.888 802.508L853.294 800.582C857.621 797 862.135 793.613 866.82 790.435L868.223 792.504C872.804 789.398 877.551 786.494 882.45 783.808L881.248 781.616C886.166 778.919 891.234 776.438 896.438 774.187L897.431 776.482C902.504 774.287 907.708 772.314 913.029 770.576L912.253 768.2C917.575 766.461 923.012 764.954 928.551 763.691L929.106 766.129C934.486 764.902 939.964 763.909 945.526 763.162L945.193 760.684C950.731 759.941 956.351 759.437 962.041 759.186L962.151 761.684C964.918 761.562 967.701 761.5 970.5 761.5C973.299 761.5 976.082 761.562 978.849 761.684L978.959 759.186C984.649 759.437 990.269 759.941 995.807 760.684L995.474 763.162C1001.04 763.909 1006.51 764.902 1011.89 766.129L1012.45 763.691C1017.99 764.954 1023.43 766.461 1028.75 768.2L1027.97 770.576C1033.29 772.314 1038.5 774.287 1043.57 776.482L1044.56 774.187C1049.77 776.438 1054.83 778.919 1059.75 781.616L1058.55 783.808C1063.45 786.494 1068.2 789.398 1072.78 792.504L1074.18 790.435C1078.87 793.613 1083.38 797 1087.71 800.582L1086.11 802.508C1090.41 806.064 1094.52 809.815 1098.42 813.745L1100.19 811.983C1104.18 815.993 1107.95 820.187 1111.51 824.551L1109.57 826.129C1113.08 830.443 1116.37 834.925 1119.42 839.559L1121.51 838.185C1124.61 842.895 1127.47 847.76 1130.07 852.767L1127.85 853.919C1130.4 858.838 1132.71 863.895 1134.74 869.073L1137.07 868.16C1139.12 873.391 1140.9 878.745 1142.4 884.207L1139.98 884.867C1141.44 890.188 1142.62 895.614 1143.51 901.129L1145.98 900.731Z",
    stroke: "#F44A4A",
    strokeWidth: 5,
    strokeDasharray: "18 18"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1050.5,
    cy: 711.5,
    r: 52.5,
    fill: "#4A90F4",
    fillOpacity: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.5,
    cy: 347.5,
    r: 52.5,
    fill: "#FFB808",
    fillOpacity: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1050.5,
    cy: 711.5,
    r: 22.5,
    fill: "#4A90F4",
    fillOpacity: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 497.5,
    cy: 359.5,
    r: 22.5,
    fill: "#FFB808"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 772,
    cy: 249.5,
    rx: 45,
    ry: 42.5,
    fill: "#14B25F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 875.264,
    y: -6.68164,
    width: 134.3,
    height: 1247.2,
    transform: "rotate(-26.5 875.264 -6.68164)",
    fill: "#FFB808"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 394,
    width: 196,
    height: 69,
    fill: "#F74037"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 463,
    width: 69,
    height: 69,
    fill: "#14B25F"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 532,
    width: 144,
    height: 69,
    fill: "#FFB808"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 601,
    width: 69,
    height: 69,
    fill: "#4A90F4"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 665,
    width: 121,
    height: 69,
    fill: "#F74037",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: -4,
    y: 325,
    width: 125,
    height: 69,
    fill: "#B3D0FA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -28.5,
    cy: 517.5,
    r: 409.5,
    stroke: "#F74037",
    strokeWidth: 76
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M447.759 770.755C440.145 766.27 430.249 768.788 426.543 776.809C389.484 857.016 425.984 953.655 505.462 1000.47C584.939 1047.29 687.158 1032.36 739.342 961.062C744.561 953.931 741.965 944.056 734.351 939.571C726.737 935.086 717.003 937.708 711.588 944.69C669.61 998.819 588.111 1012.02 521.703 972.899C455.295 933.782 427.326 856.103 454.317 793.146C457.799 785.025 455.373 775.24 447.759 770.755Z",
    fill: "#FFB808"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 750.534,
    y1: 207.18,
    x2: 670.534,
    y2: 0.180245,
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1518_124"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1536,
    height: 1024,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepage);
export default __webpack_public_path__ + "static/media/homepage.2e461b7f7370fa582733914eb768f60f.svg";
export { ForwardRef as ReactComponent };